<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type { IconProps } from '@/components/base/icon/Icon.vue'
import { Loader } from 'lucide'
import { SphIcon } from '@/components/base/icon'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

export interface SpinnerProps extends Pick<IconProps, 'size'> {
    class?: string
}

const props = withDefaults(defineProps<SpinnerProps>(), {
    class: '',
    size: 'md',
})

const mounted = ref(false)
onMounted(() => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            mounted.value = true
        })
    })
})

</script>

<template>
    <SphIcon
        :icon="Loader"
        class="[&>svg]:animate-[spin_1.25s_linear_infinite] opacity-0 transition-opacity duration-300"
        :class="mounted ? 'opacity-100' : ''"
        v-bind="props"
    />
</template>
